import { createSlice } from '@reduxjs/toolkit';

import MessagesUsersRepository from '../../repositories/Admin/MessagesUserRepository';
import { createRestSlice } from '../../utils/RestSlice';

const messagesUsersRestSlice = createRestSlice({
  resource: 'messagesUser',
  repository: MessagesUsersRepository,
  slices: ['createMessagesUser'],
});

const initialState = {
  ...messagesUsersRestSlice.initialState,
};

const messagesUsersSlice = createSlice({
  name: 'messagesUsers',
  initialState,
  reducers: {
    ...messagesUsersRestSlice.reducers,
  },
});

export default messagesUsersSlice.reducer;

export const messagesUsersRestHooks = messagesUsersRestSlice.hooks(
  messagesUsersSlice,
  ['admin', 'MessagesUsersSlice']
);
